import Vue from 'vue'
import routes from './routes'
import store from './../store'
import firebase from 'firebase'
import VueRouter from 'vue-router'
import { db } from '@/services/firebase'

Vue.use(VueRouter)
const router = new VueRouter({ mode: 'history', routes })

// Route Guard
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
  const requiresAdmin = to.matched.some(x => x.meta.requiresAdmin)
  const restrictedView = to.matched.some(x => x.meta.restrictedView)
  const guestOnly = to.matched.some(x => x.meta.guestOnly)
  const currentUser = firebase.auth().currentUser

  let userProfile = store.getters.userProfile

  if (currentUser) {
    // if userProfile has already been fetched else fetch from db
    if (userProfile.name) {
      // checks if user has permissions
      if (requiresAuth && !currentUser) {
        next('/login')
      } else if (requiresAuth && !restrictedView && !guestOnly) {
        if (requiresAdmin && !userProfile.admin) {
          next('/member/home')
        } else {
          next()
        }
        next()
      } else if (restrictedView && requiresAuth && !guestOnly) {
        if (userProfile.trial) {
          alert('Not Avalible on Trial')
          next('/member/home')
        } else {
          next()
        }
      } else if (guestOnly && !requiresAuth && !restrictedView) {
        next({ path: '/member/home' })
      } else {
        next()
      }
    } else {
      db.collection('users').doc(currentUser.uid).get().then(res => {
        userProfile = res.data()
        // checks if user has permissions
        if (requiresAuth && !currentUser) {
          next('/login')
        } else if (requiresAuth && !restrictedView && !guestOnly) {
          if (requiresAdmin && !userProfile.admin) {
            next('/member/home')
          } else {
            next()
          }
          next()
        } else if (restrictedView && requiresAuth && !guestOnly) {
          if (userProfile.trial) {
            alert('Not Avalible on Trial')
            next('/member/home')
          } else {
            next()
          }
        } else if (guestOnly && !requiresAuth && !restrictedView) {
          next({ path: '/member/home' })
        } else {
          next()
        }
      })
    }
  } else if (!currentUser && requiresAuth) {
    next('/login')
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js